export default "__VITE_ASSET__CW3oH2wa__"